module.exports = __webpack_public_path__ + "img/fig_rosalee_es.60453851.png";